import loadable from "@loadable/component";
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet-async';
import MyAppPool from '../../AppPool';
import { lng } from '../../ulanguages/language';
import { extractLinkTexts, getImgAddress, getRouteParamAtIndex, getSiteShortName } from '../../util/text';
import { getIfIsSetElems, isSet } from '../../util/typeu';
//import LoginBox from '../view_component/LoginBox';
import { getCurrentUrl, isServer } from '../../util/windowUtil';
import SpinnerBox from '../../view_component/SpinnerBox';

import './home.css';
import ContentBannerSetter from '../../view_component/ContentBannerSetter';
import ThreadPreview from "../../view_component/ThreadPreview";
import InfiniteScrollBlock from "../../view_component/InfiniteScrollBlock";
import { serverRegisterFetch } from "../../util/updateManager";
import ThreadPinned from "../../view_component/ThreadPinned";
import ThreadTag from "../../view_component/ThreadTag";
import { getForumThreadPath } from "../../store/AppRoutes";
import { toJS } from "mobx";
import Erro404 from "../../view_component/Erro404";
import ThreadMain2 from "../../view_component/ThreadMain2";
import WYSIWYGWriter from "../../view_component/WYSIWYGWriter";
import ThreadReplyWriter from "../../view_component/ThreadReplyWriter";
import ThreadComment from "../../view_component/ThreadComment";
import ScrollToTopButtom from "../../view_component/ScrollToTopButton";
import ThreadNewsPreview from "../../view_component/ThreadNewsPreview";
import SkeletonBlock from "../../view_component/SkeletonBlock";
import { getYoutubeThumbnail } from "../../util/youtube";


let pageSizeGlob = 5;
let randomThreadsSize = 6;
@observer
class ForumThread extends Component {

  constructor(props) {
    super(props);

    this.state = {currentPage:1,pageSize:pageSizeGlob, lastFetchSize:1};
    serverRegisterFetch(ForumThread.getInitialValues);
  }

  componentDidMount()
  {
    ForumThread.getInitialValues();
  }
  static async getInitialValues()
  {
    let parametersUrl = MyAppPool.cLocation.formatedUrlParameters;
    let highlightedReply=parametersUrl["cId"];
    let p3 = Promise.resolve();
    if (isSet(highlightedReply))
      p3 = MyAppPool.cNeoComu.getReply(highlightedReply);
    
    let p4 = MyAppPool.cNeoComu.getRandomSafeThreads(1,randomThreadsSize);
    let threadId = getRouteParamAtIndex(getCurrentUrl(),3);
    if (isSet(threadId))
    {
        let p1 = MyAppPool.cNeoComu.getThread(threadId);
        let p2 = MyAppPool.cNeoComu.getThreadRepliesWithHotRanking(threadId,1,pageSizeGlob);
        return Promise.all([p1,p2,p3,p4]);
    }else
    {
    return Promise.resolve();
}
  }
  componentWillReceiveProps()
  {
    ForumThread.getInitialValues();
  }

  loadNextPage = ()=>{
    let threadId = getRouteParamAtIndex(getCurrentUrl(),3);
    if (isSet(threadId))
    {
        let {lastFetchSize,currentPage,pageSize} = this.state;
        if (lastFetchSize>0)
        {
            return MyAppPool.cNeoComu.getThreadRepliesWithHotRanking(threadId,currentPage+1,pageSize).then(data=>{
                this.setState({lastFetchSize:data.length,currentPage:currentPage+1});
                return Promise.resolve();
            });
        }
        return Promise.resolve();
    }
  }

  getMedia(content) {
    const imgMatch = content.match(/<img.*?src="(.*?)"/);
    if (imgMatch)
      return imgMatch[1];
    const youtubeMatch = content.match(
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]+)/
    );
    if (youtubeMatch) {
      return getYoutubeThumbnail(youtubeMatch[1]);
    }
    return '';
  }

  render(){
    let parametersUrl = MyAppPool.cLocation.formatedUrlParameters;
    let highlightedReply=parametersUrl["cId"];
    let showHighlightedReply=false;
    if (isSet(highlightedReply))
    {
      if (isSet(MyAppPool.session.neocomu.replies[highlightedReply]))
        showHighlightedReply=true;
    }
    
    let randomThreadIDPages = MyAppPool.session.neocomu.randomSafeThreads[randomThreadsSize];
    let allRandomThreadPages=[];
    if (isSet(randomThreadIDPages)) 
    {
      allRandomThreadPages = Object.values(randomThreadIDPages).flat();
    }

    let {pageSize,currentPage} = this.state;
    let threadId = Number(getRouteParamAtIndex(getCurrentUrl(),3));
    if (isNaN(threadId))
    {
        //console.log("Thread IS NaN");
        return <Erro404 />
    }
   
    let sectionThreadIDPages = getIfIsSetElems(MyAppPool.session.neocomu.repliesToThread,[""+threadId,""+pageSize]);
    
    let allPages=[];
    if (isSet(sectionThreadIDPages)) 
    {
        allPages = Object.values(sectionThreadIDPages).flat();
    }
    let threadData = getIfIsSetElems(MyAppPool.session.neocomu.threads,[""+threadId]);

    if (MyAppPool.session.neocomu.threadsFetchStatus[''+threadId]===1 &&
      !isSet(threadData))
    {
      return <Erro404 />;
    }

    if (!isSet(threadData))
    {
        return <div  className=' contentArea uk-flex uk-flex-row'>
          <div className="threadsSection">
          <SkeletonBlock style={{width:"100%", height:"600px"}}/>
        </div>
        </div>;
    }
    let threadName = lng('Forum');
    const { title, content, datecreated, repliesAmount, views,isNSFW,isInappropriate,isSpoiler, isFeatured } = threadData.thread.properties;
    
    let img = this.getMedia(content);
    let type = lng('Forum') +' Thread';
    let keywords = extractLinkTexts(content).join(' , ') +' , '+ title; 
    threadName = title;

    if (isFeatured)
      type = lng('News');

    let meta = {title:threadName+" - "+type+' | '+getSiteShortName(),desc:'',img:img,imgwidth:'360',imgheight:'180',imgtype:'png',keywords:keywords};
    /*
    <InfiniteScrollBlock fetchFunction={this.loadNextPage}>
                {allPages.map((elemId,index)=>{
                let elem = MyAppPool.session.neocomu.threads[elemId];
                return  <ThreadPreview key={index} thread={elem} /> 
                })}
                </InfiniteScrollBlock>*/
      return (
        <div>
          <Helmet>
            <title>{meta.title}</title>
            <meta name="title" content={meta.title} />
            <meta name="description" content={meta.desc} />
            <meta name="keywords" content={meta.keywords}/>
            <meta property="og:type" content="website" />
            <meta property="og:title" content={meta.title} />
            <meta property="og:description" content={meta.desc} />
            <meta name="twitter:title" content={meta.title}/>
            <meta name="twitter:description" content={meta.desc}/>
            <meta name="twitter:image:src" content={getImgAddress(meta.img)}/>
            <meta property="og:image" content={getImgAddress(meta.img)} />
            <meta property="og:image:type" content={meta.imgtype}/>
            <meta property="og:image:width" content={meta.imgwidth}/>
            <meta property="og:image:height" content={meta.imgheight}/> 
          </Helmet>
          <div >
            <div  className=' contentArea uk-flex uk-flex-row'>
            <ContentBannerSetter />
            <div className="threadsSection">
                <div style={{marginTop:"15px"}}>
                  <ThreadMain2
                  ready={true}
                  thread= {threadData}
                  />
                </div>
                
                <ThreadReplyWriter threadId={threadId} pageSize={pageSizeGlob} />
                <div className="uk-card uk-card-default" style={{"padding":"16px","paddingTop":"8px"}}>
                
                {showHighlightedReply?
                <div style={{"marginBottom":'10px'}}>
                <h4 style={{"marginBottom":"0px"}}>{lng('Highlighted Comment')}</h4>
                <ThreadComment key={0} reply={MyAppPool.session.neocomu.replies[highlightedReply]} pageSize={pageSizeGlob}/> 
                <hr className="uk-divider-icon" />
                </div>:<></>
                }
                
                <InfiniteScrollBlock fetchFunction={this.loadNextPage}>
                {
                allPages.map((elemId,index)=>{
                let elem = MyAppPool.session.neocomu.replies[elemId];
                return  <ThreadComment key={index} reply={elem} pageSize={pageSizeGlob}/> 
                })}
                </InfiniteScrollBlock>
                </div>

                <br/>
                <div className="flexDrop">
                {allRandomThreadPages.map((elemId,index)=>{
                  return <div className="randomThreadsElement">
                    <ThreadNewsPreview key={index} thread={MyAppPool.session.neocomu.threads[elemId]} />
                    </div>
                })
                }
                </div>

            </div>
            <div className="scrollSection">
              <ScrollToTopButtom />
            </div>
            </div>
          </div>
        </div>
      );
}

}

export default ForumThread;
